'use strict'

const u = require('universalify').fromCallback
const rimraf = require('./rimraf')

module.exports = {
  remove: u(rimraf),
  removeSync: rimraf.sync
}



//////////////////
// WEBPACK FOOTER
// ./~/fs-extra/lib/remove/index.js
// module id = 159
// module chunks = 0